import { render } from "./BreadcrumbMenu.vue?vue&type=template&id=5c7c0b04&scoped=true&ts=true"
import script from "./BreadcrumbMenu.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbMenu.vue?vue&type=script&lang=ts"

import "./BreadcrumbMenu.vue?vue&type=style&index=0&id=5c7c0b04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7c0b04"]])

export default __exports__